// extracted by mini-css-extract-plugin
module.exports = {"sidebar-list":"drawers_sidebar-list__3opcn","sidebar":"drawers_sidebar__2AWKB"};